import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=5fe5a8a6&"
import script from "./confirmDialog.vue?vue&type=script&lang=js&"
export * from "./confirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports